// extracted by mini-css-extract-plugin
module.exports = {"meals":"Menu_meals__3BnAO","meals-appear":"Menu_meals-appear__3MUKu"};